const formatters = new Map();
export const formatWarrantyNumber = (value, precision = 3) => {
  if (value === null || value === undefined || value === '') return '';
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  if (!formatters.has(precision)) formatters.set(precision, new Intl.NumberFormat('vi-VN', { maximumFractionDigits: precision }));
  return formatters.get(precision).format(number);
};

export const parseWarrantyNumber = value => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
  const input = String(value ?? '').trim().replace(/\u00a0/g, '');
  if (!input) return undefined;
  if (!/^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d*)?$/.test(input)) return undefined;
  const parsed = Number(input.replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(parsed) && Math.abs(parsed) <= Number.MAX_SAFE_INTEGER ? parsed : undefined;
};
